import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { generatedPageRegistry } from "./registry";

interface IGeneratedPageHostProps {
  data?: any;
}

const GeneratedPageHost: React.FC<IGeneratedPageHostProps> = ({ data }) => {
  const location = useLocation();
  const defaultPath = generatedPageRegistry[0]?.routePath;

  return (
    <Routes location={location}>
      {defaultPath && defaultPath !== "/" && <Route path="/" element={<Navigate to={defaultPath} replace />} />}
      {generatedPageRegistry.map(route => (
        <Route
          key={route.pageId}
          path={route.routePath}
          element={<route.Component data={data} />}
        />
      ))}
      <Route
        path="*"
        element={
          <div
            style={{
              display: "flex",
              minHeight: "100vh",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 24px",
              textAlign: "center",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "var(--type-size-400)",
                fontWeight: "var(--type-weight-bold)",
                lineHeight: "var(--type-line-height-300)",
                color: "var(--color-text-strong)",
              }}
            >
              页面未生成
            </p>
            <p
              style={{
                marginTop: "var(--space-element-400)",
                fontSize: "var(--type-size-200)",
                lineHeight: "var(--type-line-height-200)",
                color: "var(--color-text-soft)",
              }}
            >
              {location.pathname}
            </p>
          </div>
        }
      />
    </Routes>
  );
};

export default GeneratedPageHost;
